import React from 'react';
import { StarIcon, TimerIcon, CheckIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { BuyButton } from './ui/BuyButton';
interface HeroProps {
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
}
export function Hero({
  countdown
}: HeroProps) {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-63" data-mp="4n1kyqg06arz">
      {/* Top Banners */}
      <div className="bg-sage-800 py-2.5 text-center" data-id="element-64" data-mp="128fs5pz8mpyv">
        <p className="px-4 text-[11px] font-bold uppercase tracking-overline text-gold-200" data-id="element-65" data-mp="xae8p3xwgomv">
          PRODUCTO 100% DIGITAL - ACCESO INMEDIATO
        </p>
      </div>
      <div className="bg-terracotta-500 py-2 text-center" data-id="element-66" data-mp="s9ggdyj6ee7n">
        <p className="flex items-center justify-center gap-2 px-4 text-[12px] font-semibold uppercase tracking-wider text-cream" data-id="element-67" data-mp="ncztf7npq5w5">
          <TimerIcon className="h-4 w-4" data-id="element-68" data-mp="3d33eqyadctkr" />
          Oferta por tiempo limitado:{' '}
          <span className="font-bold" data-id="element-69" data-mp="381nu37c3sp2w">
            {countdown.minutes}:{countdown.seconds} MINUTOS
          </span>
        </p>
      </div>

      <div className="mx-auto max-w-4xl px-5 pb-16 pt-10 text-center sm:px-8 lg:pb-24 lg:pt-16" data-id="element-70" data-mp="3j6obhix6kkpk">
        <p className="inline-flex items-center justify-center gap-2 rounded-full border border-gold-200/60 bg-bone px-4 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.2em] text-terracotta-600" data-id="element-71" data-mp="3o59d9ms2zcg4">
          PRENSAR · CONSERVAR · CREAR · VENDER
        </p>

        <h1 className="mt-8 font-serif text-[2.7rem] leading-[1.05] text-sage-900 sm:text-[4rem] lg:text-[4.5rem]" style={{
        fontWeight: "600"
      }} data-id="element-72" data-mp="30h9b7qpbjzm8">
          Aprende el arte de las{' '}
          <span className="italic text-terracotta-500" data-id="element-73" data-mp="2ql6ampa4891e">flores prensadas</span> desde
          cero
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] leading-relaxed text-ink-soft sm:text-[18px]" data-id="element-74" data-mp="2vjg5eyrxh7mh">
          Descubre cómo prensar y conservar flores reales para transformarlas en recuerdos para siempre.
        </p>

        

        <div className="mx-auto mt-8 flex w-full max-w-sm flex-col items-center gap-2.5 rounded-3xl border border-gold-200/50 bg-cream px-5 py-4 shadow-sm sm:w-auto sm:max-w-none sm:flex-row sm:gap-3 sm:rounded-full sm:py-2.5" data-id="element-75" data-mp="2lml98mj4njbd">
          <div className="flex items-center gap-3" data-id="element-76" data-mp="ibp02q9eowx0">
            <div className="flex -space-x-2" data-id="element-77" data-mp="ia5i8v83qdt4">
              <img src={testimonials[0].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-78" data-mp="ddnenyoiclid" />
              <img src={testimonials[1].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-79" data-mp="1azkvlrn8ois7" />
              <img src={testimonials[2].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-80" data-mp="15zq35jntfl51" />
            </div>
            <div className="flex items-center gap-0.5" data-id="element-81" data-mp="x1nwanhehy9u">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" data-id="element-82" data-mp="3lu07neppzt62" data-mpi={i} />)}
            </div>
          </div>
          <p className="text-center text-[12.5px] font-medium leading-snug text-sage-800 sm:text-left sm:text-[12px]" data-id="element-83" data-mp="3hq250u16s089">
            <span className="font-semibold" data-id="element-84" data-mp="1x7hupaiwtwza">4.9 / 5</span>
            <span className="hidden sm:inline" data-id="element-85" data-mp="21bpmjgknzt1q"> · </span>
            <span className="block sm:inline" data-id="element-86" data-mp="269zfdkix2hk6">
              +2.400 mujeres ya prensaron su primera flor
            </span>
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-[320px] sm:max-w-[380px]" data-id="element-87" data-mp="2b2ai0v51khgf">
          <video src="https://cdn.magicpatterns.com/uploads/2wRpXzWTbvjt7TCJ8MhCuA/IMG_4208.MOV" autoPlay loop muted playsInline className="aspect-[9/16] w-full rounded-[2rem] object-cover shadow-[0_30px_60px_-15px_rgba(56,52,44,0.3)]" data-id="element-88" data-mp="2g0ls96z90tz6" />
        </div>

        <div className="mt-12 flex flex-col items-center gap-3" data-id="element-89" data-mp="2oye606pbntkg">
          <BuyButton size="xl" label="Quiero empezar con Deco Flores" href="#oferta" data-id="element-90" data-mp="2tyaeai51y75t" />
          <p className="text-[12.5px] font-medium text-ink-light" data-id="element-91" data-mp="unj0xedciwmf">
            Producto digital · acceso inmediato
          </p>
        </div>

        <ul className="mx-auto mt-7 flex max-w-2xl flex-wrap items-center justify-center gap-x-6 gap-y-2.5" data-id="element-92" data-mp="znn7ocogcczg">
          {['No necesitas experiencia previa', 'Aprende desde casa', 'Acceso inmediato'].map(item => <li key={item} className="flex items-center gap-2 text-[13px] font-medium text-sage-800" data-id="element-93" data-mp="3vjrs687e5pqh">
              <CheckIcon className="h-4 w-4 flex-none text-sage-600" aria-hidden="true" data-id="element-94" data-mp="e77jvt5jjlkn" />
              {item}
            </li>)}
        </ul>
      </div>
    </header>;
}